import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetConversionValueMappingRecommendationResponseActionPayload } from '../SKANPostbacksConversionMapping.types';

const GetConversionValueMappingRecommendation = new ReduxAsyncAction<
  'GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION',
  string,
  GetConversionValueMappingRecommendationResponseActionPayload
>('GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION');

GetConversionValueMappingRecommendation.registerRequest(async (targetEvent: string) => {
  try {
    const response = await dash_api.get<GetConversionValueMappingRecommendationResponseActionPayload>(
      `/v1/skadnetworkv2/recommendations/mapping/${targetEvent}`
    );

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get conversion value mapping recommendation. Please try again.', 'error');

    throw error;
  }
});

export const GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION = GetConversionValueMappingRecommendation.actionNamespaceConstants;

export const getConversionValueMappingRecommendation = GetConversionValueMappingRecommendation.request;

export type GetConversionValueMappingRecommendationRequestAction = Action<
  typeof GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION.request
>;

export type GetConversionValueMappingRecommendationResponseAction = Action<
  typeof GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION.response
> & {
  data: GetConversionValueMappingRecommendationResponseActionPayload;
};
